const nb = {
  launchKicker: "Påmelding før lansering",
  launchTitle: "Hele appen lanseres innen 1. februar 2027.",
  launchBody: "Akkurat nå tester vi appen og ferdigstiller partneravtaler. Nå er tiden for bedrifter, sponsorer og kommuner å melde seg på — og få 50 % rabatt som lanseringspartner.",
  launchCta: "Meld deg på nå",
  testApp: "Prøv testappen",
  bandKicker: "For bedrifter",
  bandTitle: "Legg til dine egne troll — 50 % rabatt for lanseringspartnere.",
  bandBody: "Hoteller, kafeer, badstuer, butikker og kommuner kan melde seg på nå og ha trollene klare når appen lanseres.",
  bandCta: "Meld deg på som partner",
  kicker: "Påmelding",
  title: "Sett trollene dine på kartet.",
  lead: "Fortell oss hvem du er, velg en pakke og slipp trollene dine på kartet. Du betaler med Vipps, og vi gjør trollene klare til lansering.",
  role: "Hvem er du?",
  rolePh: "Velg …",
  roles: { homeowner: "Huseier eller privat vert", municipality: "Kommune, region eller reiselivslag", sponsor: "Sponsor", other: "Annet" },
  firstName: "Fornavn",
  lastName: "Etternavn",
  company: "Bedrift eller organisasjon",
  optional: "valgfritt",
  email: "E-post",
  phone: "Telefon",
  website: "Nettside",
  package: "Pakke",
  mapTitle: "Hvor vil du ha trollene?",
  mapHint: "Søk opp adressen din, og trykk på kartet for å slippe et troll. Dra en nål for å flytte den.",
  search: "Søk etter adresse eller sted i Norge",
  searchBtn: "Søk",
  noResults: "Fant ingen steder. Prøv et annet søk.",
  placed: "{n} av {max} troll plassert",
  full: "Alle trollene er plassert — fjern ett for å flytte det, eller velg en større pakke.",
  noPackage: "Velg en pakke først, så ser du hvor mange troll du kan plassere.",
  outside: "Troll kan bare plasseres i Norge.",
  pin: "Troll {n}",
  remove: "Fjern",
  message: "Noe vi bør vite?",
  messagePh: "Åpningstider, trollideer, spørsmål …",
  consent: "Jeg godtar at Trollfossjakten lagrer disse opplysningene for å behandle påmeldingen. Se {privacy}.",
  submit: "Meld på og gå til betaling",
  sending: "Sender …",
  summary: "Din bestilling",
  pickPackage: "Velg en pakke for å se prisen.",
  payNote: "Du betaler med Vipps etter påmeldingen. Lanseringspris: 50 % rabatt første år.",
  errors: {
    phone: "Skriv inn et gyldig telefonnummer (sifre, +, mellomrom).",
    required: "Fyll ut alle obligatoriske felt.",
    email: "Skriv inn en gyldig e-postadresse.",
    pins: "Plasser minst ett troll på kartet.",
    consent: "Godta hvordan vi lagrer opplysningene dine.",
    tooMany: "For mange påmeldinger fra denne enheten. Prøv igjen senere.",
    generic: "Noe gikk galt. Prøv igjen.",
  },
  doneKicker: "Tusen takk!",
  doneTitle: "Du er påmeldt, {name}.",
  doneBody: "Bestillingsnummeret ditt er {ref}. Vi har sendt en kopi til {email}. Betal med Vipps for å sikre lanseringsprisen.",
  doneBodyNoMail: "Bestillingsnummeret ditt er {ref}. Ta vare på det — betal med Vipps for å sikre lanseringsprisen.",
  another: "Meld på et nytt sted",
  payTitle: "Betal med Vipps",
  number: "Vipps-nummer",
  amount: "Beløp",
  ref: "Bestillingsnummer",
  copy: "Kopier",
  copied: "Kopiert",
  exVat: "Pris eks. mva",
  vat: "Mva 25 %",
  total: "Å betale",
  steps: ["Åpne Vipps og velg å sende penger", "Skriv inn nummeret {number}", "Skriv inn beløpet {amount} kr", "Skriv bestillingsnummeret {ref} i meldingen"],
  invoice: "Vil du heller ha faktura? Svar på bekreftelsen på e-post, så sender vi en.",
  host: { name: "Vertssted", for: "Kafé, gård, hytte, B&B, badstue eller butikk som tar imot trolljegere og Trollkroner", free: "Gratis" },
  mapTitleHost: "Hvor er stedet ditt — eller hvor planlegger du å åpne?",
  mapHintHost: "Søk etter adressen din, og trykk på kartet for å sette en nål. Dra den for å flytte den.",
  placePin: "Stedet ditt",
  placedHost: "{n} av 1 sted markert",
  fullHost: "Stedet ditt er markert — dra nålen for å flytte den, eller fjern den først.",
  placeTitle: "Stedet ditt",
  placeBody: "Fortell trolljegerne hva du tilbyr, og huk av alt du har.",
  offer: "Hva skal du tilby?",
  offerPh: "f.eks. kaffe og vafler, badstue, rom for natten",
  amenitiesTitle: "Hva har du? Huk av alt som passer",
  amenities: { coffee: "Kaffe", tea: "Te", snacks: "Snacks", restaurant: "Restaurant", conversations: "Samtaler", phone_charging: "Mobillading", bike_charging: "Elsykkellading", car_charging: "Elbillading", shower: "Dusj", room: "Rom", sauna: "Badstue", bnb: "Bed & breakfast", hotel: "Hotell", camping: "Camping", parking: "Parkering", toilet: "Toalett", wifi: "Wifi" },
  hostNote: "Det er gratis å være vert — ingen betaling og ingen påmeldingsavgift. Vi sjekker opplysningene og legger stedet ditt på kartet.",
  submitHost: "Registrer deg som vert",
  offerError: "Fortell oss hva du skal tilby.",
  hostDoneTitle: "Du er registrert som vert, {name}.",
  hostDoneBody: "Referansen din er {ref}. Vi har sendt en kopi til {email}. Vi sjekker opplysningene og legger stedet ditt på kartet.",
  hostDoneBodyNoMail: "Referansen din er {ref}. Ta vare på den — vi sjekker opplysningene og legger stedet ditt på kartet.",
  hostNextTitle: "Hva skjer nå",
  hostNext: ["Last ned appen og logg inn med samme e-post.", "Gå til Profil → Bli vert for å begynne å ta imot Trollkroner.", "Skann gjestens betalings-QR — appen regner ut resten som skal betales."],
  hostGetApp: "Last ned appen",
};

export default nb;
